import React from 'react'
import { withApollo } from 'react-apollo'
import { Field } from 'react-final-form'
import classNames from 'classnames'
import isEmail from 'validator/lib/isEmail'

import { checkEmailAvailabilityQuery } from '../../../lib/graphql/people'

const validateInput =
  (client, checkAvailabilityOnCav, checkAvailabilityOnUFFS) => async (value, allValues, meta) => {
    if (value && (checkAvailabilityOnCav || checkAvailabilityOnUFFS) && meta.dirty && isEmail(value)) {
      const {
        data: {
          checkEmailAvailability: { isAvailable, isAvailableOnUFFS, ldapUser },
        },
      } = await client.query({
        query: checkEmailAvailabilityQuery,
        variables: { email: value },
        fetchPolicy: 'network-only',
      })

      if (!isAvailableOnUFFS && checkAvailabilityOnUFFS) {
        return `
            Endereço de e-mail já cadastrado no <a href="https://id.uffs.edu.br">idUFFS</a> com o nome de usuário: ${ldapUser.uid}!<br/>
            Por favor, utilizar esse cadastro para acesso à rede!
          `
      }

      if (!isAvailable && checkAvailabilityOnCav) {
        return 'Endereço de e-mail já cadastrado!'
      }
    }
  }

const MailInput = ({
  name,
  label,
  helpText,
  client,
  checkAvailabilityOnCav,
  checkAvailabilityOnUFFS,
  ...props
}) => (
  <Field
    name={name}
    validate={validateInput(client, checkAvailabilityOnCav, checkAvailabilityOnUFFS)}
    format={(value) => (value ? value.toLowerCase() : '')}
  >
    {({ input, meta }) => (
      <div className="field">
        {label && <label className="label">{label}</label>}

        <div className="control">
          <input
            {...input}
            {...props}
            className={classNames('input', {
              'is-danger': meta.touched && (meta.error || meta.submitError),
            })}
            type="email"
            autoCapitalize="off"
          />
        </div>

        {!meta.touched && helpText && <p className="help">{helpText}</p>}

        {meta.touched && (meta.error || meta.submitError) && (
          <div
            className="help is-danger"
            dangerouslySetInnerHTML={{ __html: meta.error }}
          />
        )}
      </div>
    )}
  </Field>
)

export default withApollo(MailInput)
